export default __webpack_public_path__ + "static/media/dont.a4cc4e6d.gif";